import { CommonModule } from '@angular/common';
import {
    Component,
    inject,
    OnInit
} from '@angular/core';
import { IqMcEventBusStateService } from '../state';
import { IqMcEventBusStateAreaService } from '../state/services/iq-mc-event-bus-state-area.service';
import { IqMcEventBusStateLtService } from '../state/services/iq-mc-event-bus-state-lt.service';
import { IqMcEventBusStateMciService } from '../state/services/iq-mc-event-bus-state-mci.service';
import { IqMcEventBusRouteService } from '../state/services/iq-mc-event-bus-route.service';
import { IqMcRulesRegisterService } from '../state/services/mc-rules';

@Component({
    selector: 'iq-mc-event-bus-register',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-mc-event-bus-register.component.html',
    styleUrl: './iq-mc-event-bus-register.component.scss',
})
export class IqMcEventBusRegisterComponent implements OnInit {
    private _state: IqMcEventBusStateService = inject(IqMcEventBusStateService);
    private _ltState: IqMcEventBusStateLtService = inject(
        IqMcEventBusStateLtService,
    );
    private _mciState: IqMcEventBusStateMciService = inject(
        IqMcEventBusStateMciService,
    );
    private _areaState: IqMcEventBusStateAreaService = inject(IqMcEventBusStateAreaService);
    private _rulesRegister: IqMcRulesRegisterService = inject(IqMcRulesRegisterService);
    private _routeService: IqMcEventBusRouteService = inject(IqMcEventBusRouteService);

    ngOnInit() {
        this._state.initialize();
        this._ltState.initialize();
        this._mciState.initialize();
        this._rulesRegister.register();
        this._areaState.intializeEventRegister();
    }
}
